import { render, staticRenderFns } from "./EnterTerminationAddTenancy.vue?vue&type=template&id=30c360e0&scoped=true"
import script from "./EnterTerminationAddTenancy.vue?vue&type=script&lang=js"
export * from "./EnterTerminationAddTenancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c360e0",
  null
  
)

export default component.exports